import SSPContentExt from 'sspcontentext';
import { SspProviderState } from './interfaces';
import { OverlayType } from '../../components/Overlay/interfaces';
import SSPContentVO from 'sspcontentext/dist/model/SSPContentVO';
import { DataNode } from '../../utils/PickUpTypes';
import { OverlayEnum } from '../../enums';

export const SET_CONTENT_ACTION = 'SET_CONTENT';
export const SET_SSP_ACTION = 'SET_SSP';
export const SET_OVERLAY_ACTION = 'SET_OVERLAY';
export const SET_EXPOSE_ARROW_HIDDEN_ACTION = 'SET_EXPOSE_ARROW_HIDDEN';
export const SET_VIDEO_STATE_ACTION = 'SET_VIDEO_STATE';
export const OPEN_AS_SUBPAGE = 'OPEN_AS_SUBPAGE';
export const CLOSE_AS_SUBPAGE = 'CLOSE_AS_SUBPAGE';
export const RESET_AS_SUBPAGE = 'RESET_AS_SUBPAGE';
export const SET_DETAILS_NODE = 'SET_DETAILS_NODE';
export const SET_IS_TRANSLATED = 'SET_IS_TRANSLATED';

export type ACTION =
    | { type: typeof SET_CONTENT_ACTION; value: SSPContentVO }
    | { type: typeof SET_SSP_ACTION; value: SSPContentExt }
    | { type: typeof SET_OVERLAY_ACTION; value: OverlayType | null }
    | { type: typeof OPEN_AS_SUBPAGE; value: OverlayType }
    | { type: typeof CLOSE_AS_SUBPAGE }
    | { type: typeof RESET_AS_SUBPAGE }
    | { type: typeof SET_DETAILS_NODE; value: DataNode }
    | { type: typeof SET_EXPOSE_ARROW_HIDDEN_ACTION; value: boolean }
    | { type: typeof SET_VIDEO_STATE_ACTION; value: null | string }
    | { type: typeof SET_IS_TRANSLATED; value: boolean }

export const reducer = (state: SspProviderState, action: ACTION): SspProviderState => {
    switch (action.type) {
        case SET_CONTENT_ACTION:
            return {
                ...state,
                content: action.value,
            };
        case SET_SSP_ACTION:
            return {
                ...state,
                ssp: action.value,
            };
        case SET_OVERLAY_ACTION:
            return {
                ...state,
                overlay: action.value,
            };
        case OPEN_AS_SUBPAGE:
            return {
                ...state,
                asSubpageStack: [...state.asSubpageStack, action.value],
            };
        case CLOSE_AS_SUBPAGE:
            return {
                ...state,
                asSubpageStack: state.asSubpageStack.slice(0, -1),
            };
        case RESET_AS_SUBPAGE:
            return {
                ...state,
                asSubpageStack: [],
            };
        case SET_DETAILS_NODE:
            return {
                ...state,
                detailsNode: action.value,
            };
        case SET_EXPOSE_ARROW_HIDDEN_ACTION:
            return {
                ...state,
                exposeArrowHidden: action.value,
            };
        case SET_VIDEO_STATE_ACTION:
            return {
                ...state,
                videoState: action.value,
            };
        case SET_IS_TRANSLATED:
            return {
                ...state,
                isTranslated: action.value,
            };
        default:
            return state;
    }
};

export const INITIAL_STATE: SspProviderState = {
    content: null,
    ssp: null,
    overlay: {
        enum: OverlayEnum.Loading
    },
    asSubpageStack: [],
    exposeArrowHidden: false,
    videoState: null,
    detailsNode: null,
    isTranslated: false
};
